import { createContext, useMemo } from 'react';
import { ITEMS } from 'consts/localStorage';
import { isClient } from 'functions/isClient';

export const InAppContext = createContext();

export const InAppContextProvider = ({ children }) => {
  const isInApp = useMemo(() => {
    if (!isClient()) return false;

    return !!localStorage.getItem(ITEMS.inApp);
  }, []);

  return <InAppContext.Provider value={isInApp}>{children}</InAppContext.Provider>;
};
